module.exports = __webpack_public_path__ + "static/media/icon-cartoon-dot.24c131ba.svg";